__turbopack_context__.v({
  "className": "ibm_plex_mono_857a9614-module__nkOQqG__className",
  "variable": "ibm_plex_mono_857a9614-module__nkOQqG__variable",
});
